import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './ProductassetAPI';
import {getColumns} from './ProductassetStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getProductassetView} from './ProductassetView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteProductassetObj  ,setSelectedProductassetId,setProductassetViewModal,setSelectedActionId , setShowEditForProductasset} from 'store/slice/PharmaSlice';

import ProductassetListTable from './components/ProductassetListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';


import FullscreenIcon from '@mui/icons-material/Fullscreen';

import ViewActionModal from './action/view/ViewActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function ProductassetListImpl( {tableList, cardList, setShowEdit, setProductassetId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice);
  const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, productassetObj} = useSelector((state)=>state.pharmaslice.productassetDashboard);
  const { productassetList } = useSelector((state) => state.pharmaslice.productassetDashboard);

  useEffect(() => {
  }, [productassetList, productassetObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedProductassetId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteProductassetObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedProductassetId(id));
    dispatch(setShowEditForProductasset(true));
  }
  
  const createProductasset=()=>{
    dispatch(setSelectedProductassetId(-1));
    dispatch(setShowEditForProductasset(true));
  }


  const viewCallBack = (id) =>{
    dispatch(setSelectedProductassetId(id));
    dispatch(setProductassetViewModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,
		'orderedon': transformDateValue(data.orderedon),
		'receivedon': transformDateValue(data.receivedon)
    }
    return newData;
  }
  const productassetTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }
  const getActionList = () =>{
    if (productObj.designstatus==="DESIGN READY")
      return [
        {id:47, title:'View', callBackMethod:viewCallBack, icon:<FullscreenIcon/>, status:'Draft', role:''},
      ] 
    else 
      return [
      {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon disabled={true}/>, status:'NA'},
      {id:47, title:'View', callBackMethod:viewCallBack, icon:<FullscreenIcon/>, status:'Draft', role:''},
    ]
  }
  const payload = {
    productassetList:productassetList,
    cardList:getProductassetView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:47, title:'View', callBackMethod:viewCallBack, icon:<FullscreenIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:productassetTransformation(tableList),
      productassetList:productassetList,
      actionList:getActionList()
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column" padding={2}>
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'}>
                      <Grid item>
                        <Typography variant='h4'>Product 's Asset List</Typography>
                      </Grid>
                      {/* <Grid item>
                        <Grid container justifyContent={'flex-end'} spacing={1}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            }
                            <Grid item>
                              <Tooltip title="Add Productasset" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createProductasset()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid> */}
                      
                  </Grid>
              </Grid>
              <Grid item>
                  { view===0? 
                      <CardListLayout payload={getPayload()}/>
                    :
                    <MyPageContainer  containedComponent = {
                      < ProductassetListTable 
                        payload={getPayload().tableView}
                        />
                    }/>
                  }
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<ViewActionModal/>
    </>
);


}